import { DateTime as DT } from 'luxon';

/** Start of today in local timezone (unix millis) — document creation date default. */
export const getTodayDocumentDateMillis = (): number => DT.local().startOf('day').toMillis();

/**
 * Document number: `{entityId}-{sequence}{letter}`
 * e.g. `42-3О` (object) or `15-1Л` (lead).
 */
export const buildDocumentNumber = (
    entityId: number | string,
    sequence: number,
    letter: string,
): string => {
    const id = Number(entityId);
    const seq = Math.max(1, Math.floor(Number(sequence) || 1));
    const suffix = String(letter || '').trim();
    if (!Number.isFinite(id) || id <= 0) return suffix ? `${seq}${suffix}` : String(seq);
    return `${id}-${seq}${suffix}`;
};

export const buildDefaultDocumentMeta = (params: {
    entityId: number | string;
    sequence: number;
    letter: string;
}): { proposalNumber: string; proposalDt: number } => ({
    proposalNumber: buildDocumentNumber(params.entityId, params.sequence, params.letter),
    proposalDt: getTodayDocumentDateMillis(),
});
